import React from "react";
import {
  errorAlertSvg,
  informationAlertSvg,
  questionAlertSvg,
  shieldSvg,
  successAlertSvg,
} from "./Assets";
import OutlineBlueBtn2 from "./buttons/OutlineBlueBtn2";
import OutlineSubBtn from "./buttons/OutlineSubBtn";
import SmallPopup from "./modal/SmallPopup";
import Spinner from "./spinner/Spinner";

const AppAlert = ({
  title,
  desc,
  open,
  onClose,
  onOk,
  cancelText = "",
  okText = "",
  type,
  okButtonRed,
  loading = false,
}) => {
  const renderIcon = () => {
    switch (type) {
      case "success":
        return successAlertSvg;
      case "question":
        return questionAlertSvg;
      case "info":
        return informationAlertSvg;
      case "checked":
        return shieldSvg;
      case "error":
        return errorAlertSvg;
      default:
        break;
    }
  };

  return (
    <SmallPopup open={open}>
      <div className="flex flex-col justify-center items-center gap-6">
        {type && <img alt="exclude" src={renderIcon()} className="w-12 h-12" />}
        <p className="flex flex-col justify-center items-center">
          {title && (
            <b dangerouslySetInnerHTML={{ __html: title }} className="mb-2 w-full text-center alert-title" />
          )}
          {desc && (
            <span
              dangerouslySetInnerHTML={{ __html: desc }}
              className="text-center alert-title-desc text-darkblue text-15 "
            />
          )}
        </p>
        <div className="popup-btns">
          {onClose && (
            <OutlineSubBtn onClick={onClose}>{cancelText}</OutlineSubBtn>
          )}
          {okButtonRed ? (
            <button className="py-3 outline-red-btn" onClick={onOk}>
              <Spinner isLoading={loading} />
              {okText}
            </button>
          ) : (
            <OutlineBlueBtn2
              className="py-3"
              onClick={() => {
                if (!loading) {
                  onOk();
                }
              }}
            >
              <Spinner isLoading={loading} color="#3451d7" />
              {okText}
            </OutlineBlueBtn2>
          )}
        </div>
      </div>
    </SmallPopup>
  );
};

export default AppAlert;
